// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface V1IsolationUnit
 */
export interface V1IsolationUnit {
  /**
   *
   * @type {string}
   * @memberof V1IsolationUnit
   */
  awsAccountId?: string;
  /**
   *
   * @type {string}
   * @memberof V1IsolationUnit
   */
  azureSubscriptionId?: string;
  /**
   *
   * @type {string}
   * @memberof V1IsolationUnit
   */
  gcpProjectId?: string;
  /**
   *
   * @type {string}
   * @memberof V1IsolationUnit
   */
  id?: string;
}

/**
 * Check if a given object implements the V1IsolationUnit interface.
 */
export function instanceOfV1IsolationUnit(
  value: object,
): value is V1IsolationUnit {
  return true;
}

export function V1IsolationUnitFromJSON(json: any): V1IsolationUnit {
  return V1IsolationUnitFromJSONTyped(json, false);
}

export function V1IsolationUnitFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1IsolationUnit {
  if (json == null) {
    return json;
  }
  return {
    awsAccountId:
      json['aws_account_id'] == null ? undefined : json['aws_account_id'],
    azureSubscriptionId:
      json['azure_subscription_id'] == null
        ? undefined
        : json['azure_subscription_id'],
    gcpProjectId:
      json['gcp_project_id'] == null ? undefined : json['gcp_project_id'],
    id: json['id'] == null ? undefined : json['id'],
  };
}

export function V1IsolationUnitToJSON(json: any): V1IsolationUnit {
  return V1IsolationUnitToJSONTyped(json, false);
}

export function V1IsolationUnitToJSONTyped(
  value?: V1IsolationUnit | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    aws_account_id: value['awsAccountId'],
    azure_subscription_id: value['azureSubscriptionId'],
    gcp_project_id: value['gcpProjectId'],
    id: value['id'],
  };
}
